
import auth from './AuthAPI.js'
import * as APPCONFIG from '../config/app-config.js'
import Http from './Http.js';

class VechiclesApi {


    saveVehicle(form) {
        return auth({
          method: "post",
          headers: Http.MULTIPART_HEADERS(),
          url: `${APPCONFIG.API_URL}api/saveVehicleV2`,
          data:  form,
        });
      }   

   
      editVehicle(form) {
        return auth({
            method: "post",
            headers: Http.MULTIPART_HEADERS(),
            url: `${APPCONFIG.API_URL}api/editVehicleV2`,
            data: form,
          });
      }

      
       
      getVehicleList(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/getVehicleList`,
            data: JSON.stringify(form),
          });
      }

      deleteVehicle(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/deleteVehicle`,
            data: JSON.stringify(form),
          });
      }

     
      getVehicleReport(form){
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/getVehicleReport`,
          data: JSON.stringify(form),
        });
      }

      getVehiclePdfReport(form){
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/getVehiclePdfReport`,
          data: JSON.stringify(form),
        });
      }


      
}

export default new VechiclesApi();